<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <span class="configurationBannerLabel">Mechanical Connections</span>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (handArrangementSelection) {
          <span class="halfWidthConfigurationInput">
            <span class="halfWidthInputLabel">Unit Arrangement:</span>
            <select
              class="halfWidthInputField"
              #handArrangementInput
              [class.invalidConfigurationSelection]="isInvalidSelection(handArrangementSelection.Name)"
              (change)="selectionChanged(handArrangementSelection, handArrangementInput.value)"
              [value]="handArrangementSelection.Value.toString()">
              @for (allowable of handArrangementSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid"
                  class="configurationSelectionOption"
                  [selected]="handArrangementSelection.Value && handArrangementSelection.Value.toString() === allowable.Value"
                  [value]="allowable.Value">
                  {{ allowable.Description }}
                </option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (handArrangementImagePath().trim().length > 0) {
          <img class="handArrangementImage" [src]="handArrangementImagePath()" alt="UnitImage" />
        }
      </div>
      @if (dimensionalData(); as dimensions) {
        <div class="configurationDetailRow">
          <span class="fullWidthConfigurationInput">
            <span class="dimension-value-wrapper">
              <span class="dimension-label">Length:</span>
              <span class="dimension-value">{{ dimensions.length }}</span>
              <span class="units-label">inches</span>
            </span>
            <span class="dimension-value-wrapper">
              <span class="dimension-label">Width:</span>
              <span class="dimension-value">{{ dimensions.width }}</span>
              <span class="units-label">inches</span>
            </span>
            <span class="dimension-value-wrapper">
              <span class="dimension-label">Height:</span>
              <span class="dimension-value">{{ dimensions.height }}</span>
              <span class="units-label">inches</span>
            </span>
          </span>
        </div>
      }
    </div>
  }
</div>
